<p>The current version of this app is no longer supported. Please update the latest version to continue using Homey</p>

<div class="flex flex-row justify-center">
<p-button size="small" class="mt-4" (onClick)="onUpdateClick()">Open app store</p-button>
</div>
